import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';

import './GridRetargetingNameCell.css';
import * as keyset from './GridRetargetingNameCell.i18n';

const i18n = i18nFactory(keyset);

export interface GridRetargetingNameCellProps {
    id: string;
    name: string;
}

const BLOCK = 'grid-retargeting-name-cell';

export const GridRetargetingNameCell = React.memo(
    (props: GridRetargetingNameCellProps) => {
        const { name, id } = props;

        return (
            <>
                <div className={Bem.cls(BLOCK, 'title')}>{name}</div>
                <div
                    className={classNames(
                        Bem.cls(BLOCK, 'id'),
                        TestBem.cls(BLOCK, 'id')
                    )}
                >
                    {i18n('number', { id })}
                </div>
            </>
        );
    }
);
